import { createTheme } from '@material-ui/core';

declare module '@material-ui/core/styles/createBreakpoints' {
  interface BreakpointOverrides {
    fullhd: true;
    lg1: true;
  }
}

const muiBreakpoints = createTheme({
  breakpoints: {
    values: {
      fullhd: 1920,
      xl: 1440,
      lg1: 1280,
      lg: 1024,
      md: 768,
      sm: 375,
      xs: 0,
    },
  },
  palette: {
    primary: {
      main: '#4F2651',
    },
  },
});

export default muiBreakpoints;
